import "./index.scss";

import React from "react";
import { connect } from "react-redux";

import Search from "./Actions/Search/Search";

@connect(store => {
    return {
        workstreams: store.workstreams,
    };
})

class ReassignLead extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: null,
            isClose: false
        }
    }

    render() {
        const { workstreams, dispatch } = this.props;

        const handleSelectLead = (value) => {
            this.setState({...this.state, selected: value, isClose: false});
        }

        const handleReassign = () => {
            $(`#reassignLead`).modal("hide");

            dispatch({
                type: "UPDATE_WORKSTREAMS_SELECTED", 
                selected: {
                    ...workstreams.selected, 
                    members: [
                        ...workstreams.selected.members.filter(m => m.id !== this.state.selected.value).map(m => ({
                            ...m, 
                            assign: "assignedTo", 
                            isNewLead: false
                        })), 
                        {
                            ...this.state.selected.others, 
                            assign: "responsible", 
                            isNewLead: true
                        }
                    ]
                }
            });

            this.setState({...this.state, isClose: true});
        }

        const handleClose = () => {
            this.setState({...this.state, isClose: true});
        }

        return (
            <div class="modal fade confirm-modal bg-overlay" data-backdrop="static" data-keyboard="false" id="reassignLead">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header bb pd20 pdl40 pdr40">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="text-size18 brndnTxt-m mb0 mt5">Re-assign the Workstream Lead</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a  class="text-right text-black" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body pt10 pb10">
                            <p class="mb20">By removing the Workstream Lead, you are required to re-assign the role to another user.</p>
                            <div class="reassignLeadContainer">
                                <span class="mr20">Re-assign Lead to:</span>
                                <i class="material-icons searchIcon">search</i>
                                <Search projectId={this.props.projectId} onChange={handleSelectLead} isClose={this.state.isClose} avatarBaseUrl={`/api/file/profile_pictures/`} />
                            </div>
                        </div>
                        <div class="modal-footer bt">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <button type="button" class="btn btnCancel ml0" data-dismiss="modal" onClick={handleClose}>Cancel</button>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                    <button type="button" class={`btn btnSave ${!this.state.selected ? "disabled" : ""}`} onClick={handleReassign}>Re-assign</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReassignLead;
